import routes from '../../config/settings/routes'
import {
  HelpCard,
  HelpCardBody,
  HelpCardCopy,
  HelpCardLink,
  HelpCardTitle,
} from './Support.styles'

const SupportHelpCard = () => (
  <HelpCard>
    <HelpCardCopy>
      <HelpCardTitle>¿Algo no cuadra? Escríbenos.</HelpCardTitle>
      <HelpCardBody>
        Soporte, un comentario o una consulta comercial. Queda registrado para
        hacer seguimiento.
      </HelpCardBody>
    </HelpCardCopy>
    <HelpCardLink to={routes.help}>Ir a contacto</HelpCardLink>
  </HelpCard>
)

export default SupportHelpCard
